











import GiganautVue from '@/components/Shared/GiganautVue';
import { ContactAnonModule } from '@/store/modules/contactAnon';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'Error',
  components: {  }
})
export default class Error extends Vue {

  get errorMessage() {
      return ContactAnonModule.errorMessage;
  }

  get isError() {
      return ContactAnonModule.isError;
  }
}
